import React from 'react';
import { Dropdown } from '@ihsm/ui-shared';
import { DropdownOption } from '@ihsm/ui-shared/lib/typings/shared/components/DropdownButton';
import { useActions, useAppSelector } from 'state/store';

export const FundDropdown: React.FC = () => {
  const { setSelectedFund } = useActions();
  const { selectedFund, fundsList } = useAppSelector(
    (state) => state.fundsState
  );

  const options: DropdownOption[] = fundsList.map((fund) => ({
    displayText: fund,
    value: fund,
  }));

  const fundChangeHandler = (fund: string) => {
    if (selectedFund !== fund) {
      setSelectedFund(fund);
    }
  };

  return (
    <Dropdown
      labelText="Fund"
      value={selectedFund}
      options={options}
      onChange={fundChangeHandler}
    />
  );
};
